const ACTION_TYPE = {
  GET_DASHBOARD_SUMMARY: 'GET_DASHBOARD_SUMMARY',
  GET_LANGUAGE: 'GET_LANGUAGE',

  SELECT_ITEM: 'SELECT_ITEM',
  UPDATE_CLIENT_DATA: 'UPDATE_CLIENT_DATA',
  CLEAR_CLIENT_DATA: 'CLEAR_CLIENT_DATA',
};

export default ACTION_TYPE;
